module.exports = __webpack_public_path__ + "img/11.1ee2b90a.jpg";